import {Web3AuthSignatureGroup} from '#/hooks/use-web3auth-signature-group';
import {ApiBodyWithoutSignature, fetchFromApiRoute, fetchFromApiRouteWithSignature} from '#/utils/fetch-utils';
import {ApiWishlist, apiWishlist} from 'shareland-common';

const get = async (params: ApiWishlist['get']['reqQuery']): Promise<ApiWishlist['get']['resBody']['data']> => {
  const res = await fetchFromApiRoute<ApiWishlist['get']>(apiWishlist.endpoints.get, {
    paramsDictionary: null,
    reqBody: null,
    reqQuery: params,
  });

  return res ?? null;
};

const add = async (
  params: ApiBodyWithoutSignature<ApiWishlist['add']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiWishlist['add']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiWishlist['add']>(
    apiWishlist.endpoints.add,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

const remove = async (
  params: ApiBodyWithoutSignature<ApiWishlist['remove']['reqBody']>,
  web3AuthSignatureGroup: Web3AuthSignatureGroup,
): Promise<ApiWishlist['remove']['resBody']['data']> => {
  const res = await fetchFromApiRouteWithSignature<ApiWishlist['remove']>(
    apiWishlist.endpoints.remove,
    {
      paramsDictionary: null,
      reqBody: params,
      reqQuery: {},
    },
    web3AuthSignatureGroup,
  );

  return res ?? null;
};

export const apiWishlistRequests = {
  get,
  add,
  remove,
};
